'use client';

import type { CheckoutLifecycleEvent } from './CheckoutLifecycleEvent';
import { useOnCheckoutLifecycle } from './useOnCheckoutLifecycle';

/**
 * Subscribe to a checkout being ENDED — the buyer dismissed the success screen
 * (tapped "Done" / the ✕) and returned to the opener. Fires after a `success`.
 * Use it to run "the buyer finished with this completed checkout" side effects
 * (e.g. refocus / advance the surface that launched it). See
 * {@link useOnCheckoutLifecycle} for the stability contract.
 */
export function useOnCheckoutEnded(
  listener: (event: CheckoutLifecycleEvent) => void,
): void {
  useOnCheckoutLifecycle('ended', listener);
}
